import React, {Component} from "react";
import axios from "axios";
import Loading from "../Loading";
import {Link} from "react-router-dom";
import {Redirect} from "react-router";

class BPUserCreate extends Component{
    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            username:'',
            branchCode:'',
            email:'',
            bankCode:'FWD',
            authorities:[],
        }
        const roles = [{name:'Quản trị viên', value:'ROLE_ADMIN'}, {name:'Xem báo cáo', value:'ROLE_BANCA'}, {name:'Quản lý báo cáo hoa hồng', value:'ROLE_STAFF_FWD'}, {name:'Quản lý báo cáo thi đua', value:'ROLE_BANCA_CONTEST'}]
        this.state = {
            roles: roles,
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
        }
        this.isAuthorityChecked = this.isAuthorityChecked.bind(this);
        this.handleOnchangeUsername = this.handleOnchangeUsername.bind(this);
        this.handleOnchangeEmail = this.handleOnchangeEmail.bind(this);
        this.handleOnchangeBranchCode = this.handleOnchangeBranchCode.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
    }

    isAuthorityChecked(role){
        const {item} = this.state;
        return item?.authorities.includes(role);
    }
    handleOnchangeUsername(e){
        const {item} = this.state;
        item.username = e?.target?.value?.toUpperCase();
        this.setState({item: item});
    }
    handleOnchangeEmail(e){
        const {item} = this.state;
        item.email = e?.target?.value;
        this.setState({item: item});
    }
    handleOnchangeBranchCode(e){
        const {item} = this.state;
        item.branchCode = e?.target?.value;
        this.setState({item: item});
    }

    handleSubmit(){
        const {item} = this.state;
        if(item?.username === ''){
            this.setState({errorMessage: 'Vui lòng nhập tên tài khoản!'})
            return ;
        }
        if(item?.branchCode === ''){
            this.setState({errorMessage: 'Vui lòng nhập mã văn phòng!'})
            return ;
        }
        if(item?.authorities.length === 0){
            this.setState({errorMessage: 'Vui lòng chọn quyền cho tài khoản!'})
            return ;
        }
        this.setState({isLoading: true})
        axios.post('/api/bankportal/user/create/', item)
            .then(response => {
                this.setState({successMessage: 'Cập nhật thông tin thành công',errorMessage:'', isLoading: false})
                return <Redirect to={'/bp/user/edit/'+response?.data?.username} />
            })
            .catch(error => {
                console.log(error);
                this.setState({errorMessage: 'Xảy ra lỗi khi tạo mới thông tin người dùng !',successMessage:'', isLoading: false})
            })
    }

    render() {
        const {roles, item, isLoading,errorMessage, successMessage} = this.state;
        if(isLoading === true) return <Loading />;
        const handleOnchangeRoles = (role) => {
            const {item} = this.state;
            const index = item?.authorities?.indexOf(role);
            if(index > -1){
                item?.authorities?.splice(index, 1)
            }else{
                item?.authorities.push(role);
            }
            this.setState({item: item});
        }

        return (
            <div className={'report mx-5'}>
                <div className={'div-center'}>
                    <div className={'content'}>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">CẬP NHẬT - THÔNG TIN TÀI KHOẢN</h2>
                        <form>
                            <div className="form-group">
                                <label className="control-label col-sm-3">Tài khoản đăng nhập</label>
                                <div className="col-sm-9">
                                    <input className={"form-control"} value={item?.username} onChange={this.handleOnchangeUsername}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3">Mã ngân hàng</label>
                                <div className="col-sm-9">
                                    <span>{item?.bankCode}</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3">Mã văn phòng</label>
                                <div className="col-sm-9">
                                    <input className={"form-control"} value={item?.branchCode} onChange={this.handleOnchangeBranchCode}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3">Email</label>
                                <div className="col-sm-9">
                                    <input className="form-control" value={item?.email} onChange={this.handleOnchangeEmail}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3">Phân quyền</label>
                                <div className="col-sm-9">
                                    <ul>
                                        {roles.map(role => {
                                            return (
                                                <li key={role?.value}>
                                                    <input
                                                        id={'custom-checkbox-${index}'}
                                                        name="{role.name}"
                                                        value={role.value}
                                                        checked={this.isAuthorityChecked(role.value)}
                                                        onChange={() => handleOnchangeRoles(role.value)}
                                                        type="checkbox"
                                                        className={'mr-1'} />
                                                    <label>{role.name}</label>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/user/list'} className="btn btn-success">Quay về</Link>
                                    {item?.isConfirmed !== 'Y' && <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">Tạo mới tài khoản</button>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default BPUserCreate;
